// @flow

import React from 'react';
import { Box } from 'gestalt';

type Props = {|
  isHorizontalDesign: boolean,
|};

const BACKGROUND_HEIGHT_PIXELS = 136;
const placeholderStyle = {
  __style: { opacity: 0.5 },
};

export default function AvatarHoverCardFollowingText({ isHorizontalDesign }: Props) {
  if (isHorizontalDesign) {
    return (
      <Box height="100%" width="100%" display="flex" direction="row" position="absolute" top left>
        <Box
          dangerouslySetInlineStyle={placeholderStyle}
          color="midnight"
          height="100%"
          width="100%"
          flex="grow"
        />
        <Box color="white" width="2px" flex="none" />
        <Box dangerouslySetInlineStyle={placeholderStyle} color="olive" width="100%" flex="grow" />
        <Box color="white" width="2px" flex="none" />
        <Box dangerouslySetInlineStyle={placeholderStyle} color="maroon" width="100%" flex="grow" />
      </Box>
    );
  }
  return (
    <Box height="100%" width="100%" display="flex" direction="row" position="absolute" top left>
      <Box
        dangerouslySetInlineStyle={placeholderStyle}
        color="midnight"
        height="100%"
        flex="grow"
      />
      <Box color="white" width="2px" flex="none" />
      <Box display="flex" height={BACKGROUND_HEIGHT_PIXELS} direction="column" flex="grow">
        <Box dangerouslySetInlineStyle={placeholderStyle} color="olive" width="100%" flex="grow" />
        <Box color="white" height="2px" flex="none" />
        <Box dangerouslySetInlineStyle={placeholderStyle} color="maroon" width="100%" flex="grow" />
      </Box>
    </Box>
  );
}
